let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5U6Eb")).then(() => parcelRequire('ji4L0'));